import { AccessTokenStore } from './accessTokenStore';
import { refreshAccessToken } from './refreshAccessToken';
export const getAccessToken = async (walletAddress) => {
    const store = AccessTokenStore.getInstance();
    if (store.accessToken && store.isAuthenticated(walletAddress))
        return { token: store.accessToken, success: true };
    const response = await refreshAccessToken(walletAddress);
    return response;
};
